import { render, staticRenderFns } from "./ViewRewards.vue?vue&type=template&id=a0656a50&scoped=true"
import script from "./ViewRewards.vue?vue&type=script&lang=js"
export * from "./ViewRewards.vue?vue&type=script&lang=js"
import style0 from "./ViewRewards.vue?vue&type=style&index=0&id=a0656a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0656a50",
  null
  
)

export default component.exports